<template>
  <div class="faq-holder">
    <div class="container">
      <div class="row">
        <div class="col col-10 offset-1 faq">
          <h2>Frequently Asked Questions</h2>
          <div class="questions row">
            <div v-for="(group, idx) in dataStructure()" :key="idx" class="col col-6">
              <div
                v-for="(qa, i) in group" :key="i" class="qa-holder"
                :class="{ 'expanded': qa.expanded }"
              >
                <div class="heading" @click="toggleFAQ(i)">
                  <h4>{{ qa.question }}</h4>
                  <IconExpand />
                </div>
                <p class="body-1">
                  {{ qa.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconExpand from '../../assets/svg/icon-faq-expand.svg?vue-component';

export default {
  components: {
    IconExpand,
  },
  data() {
    return {
      faq: [
        {
          question: 'What does ‘billed once’ mean for this course?',
          answer: 'Unlike a Premium subscription to our platform (billed monthly or annually), acquiring individual courses requires a one-time payment. The course is hosted by 365 Data Science and comes with extra perks like a resume builder, user dashboard, Q&A hub, and gamified features.',
          expanded: false,
        },
        {
          question: 'Can I access other courses on the platform when I buy this one?',
          answer: 'Our limited-time offer covers individual course purchases only. If you’re interested in the entire curriculum on our platform or want to enroll in a more extensive career track, consider continuing your data science journey with one of our subscription plans.',
          expanded: false,
        },
        {
          question: 'Do I have a time limit for completing the course?',
          answer: 'Purchasing this course makes it yours forever. There is no time requirement for completing the modules or assignments. All perks and materials are accessible indefinitely—even after you complete the course. The only timed component is the exam. Whether you pass or fail, you can retake it limitless times. But you must watch at least 30 minutes of video content before each attempt.',
          expanded: false,
        },
        {
          question: 'How do I get a Course Certificate?',
          answer: 'All enrolled students have access to the course exams—no matter how many lessons they’ve watched. You receive a Course Certificate if you get an exam score of 60% or above. Your certificate of achievement is generated automatically once you pass the exam; you can download, view, and share it anytime.',
          expanded: false,
        },
        {
          question: 'How long will my certificate be valid?',
          answer: 'Your Course Certificate has no expiration date. Once you pass the exam, it’s yours forever. You’ll never need to worry about validity issues or retaking the course (unless you wish to refresh your knowledge).',
          expanded: false,
        },
        {
          question: 'Do I need prior experience or an academic degree to take the course?',
          answer: 'No, there are no prerequisites for enrolling. Everything you need to know is included in the course. Unlike other platforms which usually consider mathematics and statistics as prerequisites, we offer beginner-friendly content. We explain it all step by step, including how to download and install the necessary software, e.g., Anaconda, Jupyter Notebook, Python, R, MySQL, Tableau Public, etc.',
          expanded: false,
        },
      ],
    };
  },
  methods: {
    dataStructure() {
      const cols = this.$store.state.layout === 'desktop' ? 2 : 1;
      const data = this.faq || {};

      const chunkSize = Math.ceil(data.length / cols);
      const dataArray = [];
      for (let i = 0; i < data.length; i += 1) {
        const chunkIndex = Math.floor(i / chunkSize);

        if (!dataArray[chunkIndex]) {
          dataArray[chunkIndex] = [];
        }

        dataArray[chunkIndex].push(data[i]);
      }
      for (let i = 0; i < dataArray.length; i += 1) {
        dataArray[i] = [...dataArray[i]];
      }

      return dataArray;
    },
    toggleFAQ(id) {
      if (this.$store.state.layout === 'mobile') {
        this.faq[id].expanded = !this.faq[id].expanded;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-holder {
  // padding-top: 160px;

  .faq {
    .heading {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: var(--spacing-16);
    }

    h4 {
      margin: 0;
      font-size: 24px;
    }

    svg {
      display: none;
      margin-left: var(--spacing-18);
      flex: 0 0 auto;

      path[stroke] {
        stroke: var(--main-dark);
      }
    }

    h2 {
      max-width: 370px;
      margin-bottom: var(--spacing-60);
    }

    .questions {
      display: flex;
      flex-wrap: wrap;

      .qa-holder {
        margin-bottom: var(--spacing-60);

        &.expanded {
          svg {
            transform: rotate(90deg);
          }
        }
      }

      .body-1 {
        margin: 0;
        color: var(--main-dark-light-3);
      }
    }
  }
}

@include bp($bp-mobile) {
  .faq-holder {
    .faq {
      h2 {
        margin-bottom: var(--spacing-18);
      }

      .heading {
        cursor: pointer;
      }

      h4 {
        font-size: 16px;
      }

      svg {
        display: block;
      }

      .questions {
        > div:first-of-type {
          padding-right: 0;
        }

        > div:last-of-type {
          padding-left: 0;
        }

        .qa-holder {
          padding: var(--spacing-18) 0;
          margin-bottom: 0;

          &:not(:last-of-type) {
            border-bottom: 1px solid rgba(0, 12, 31, 0.12);
          }

          .body-1 {
            max-height: 0;
            overflow: hidden;
            transition: all 500ms cubic-bezier(0, 1, 0, 1);
          }

          &.expanded {
            .body-1 {
              max-height: 9999px;
              transition: max-height 1s ease-in-out;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>
